import axios from 'axios';

const updateMetrics = metrics => axios.put('metrics', { metrics });

const exportMetric = ({ id, start, end, compare, raw }) => {
  return axios.post(`metrics/${id}/export`, { start, end, compare, raw });
};

export { updateMetrics, exportMetric };
